import { Close } from '@mui/icons-material';
import { DialogTitle, Stack, Typography } from '@mui/material';
import React from 'react';

const styles = {
    dialogTitleStyle: {
        padding: '16px!important',
        color: 'white',
        height: '64px',
        borderRadius: '8px 8px 0px 0px !important',
        display: 'flex',
        justifyContent: 'space-between',
        borderBottom: '1px solid #0000001F',
    },
};

const DialogHeader = ({ dialogTitle, onClose }) => {
    return (
        <DialogTitle sx={styles.dialogTitleStyle}>
            <Typography variant="h6" width={'98%'} color={'#000000DE'}>
                {dialogTitle}
            </Typography>
            <Stack direction={'row'} spacing={0}>
                <div onClick={onClose} style={{ cursor: 'pointer', height: '32px' }}>
                    <Close style={{ fill: '#000000DE', fontSize: 32 }} />
                </div>
            </Stack>
        </DialogTitle>
    );
};

export default DialogHeader;
